module.exports = __webpack_public_path__ + "img/img_left_nav_bet_hover.a6256b52.svg";